<div
  class="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#eef6ff] via-[#f6f9ff] to-[#e6f7fb] px-4"
>
  <div class="w-full max-w-md">
    <!-- Card -->
    <div
      class="bg-white/90 backdrop-blur rounded-3xl shadow-xl border border-blue-100 p-8 transition-all"
    >
      <!-- Header / Brand -->
      <div class="flex flex-col items-center text-center mb-6">
        <div class="flex items-center gap-3 mb-2">
          <img src="assets/logo.svg" alt="Himalaya Salud" class="h-10 w-10 object-contain" />
          <div class="text-left">
            <div class="text-lg font-semibold text-gray-800">
              Himalaya <span class="text-[#177686] font-bold">Salud</span>
            </div>
            <div class="text-xs text-gray-500">Tu salud en tus manos</div>
          </div>
        </div>
        <h2 class="text-xl font-semibold text-gray-700 mt-3">Bienvenido</h2>
        <p class="text-sm text-gray-400">Ingresá tus datos para continuar</p>
      </div>

      <!-- Form -->
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <!-- Email -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Email</mat-label>
          <input matInput type="email" placeholder="ejemplo@email.com" formControlName="email" />
        </mat-form-field>

        <!-- Password -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Contraseña</mat-label>
          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            placeholder="••••••••"
            formControlName="password"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hidePassword = !hidePassword"
            [attr.aria-label]="'Toggle password visibility'"
            [attr.aria-pressed]="!hidePassword"
          >
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>

        <!-- Button -->
        <button
          type="submit"
          [disabled]="form.invalid"
          class="w-full py-3 rounded-xl font-semibold text-white bg-[#177686] hover:bg-[#145e6b] transition-all shadow-md disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed"
        >
          Acceder
        </button>

        <!-- Forgot -->
        <div class="text-center pt-2">
          <button
            type="button"
            (click)="gotoForgotPassword()"
            class="text-sm text-[#177686] hover:text-[#145e6b] transition-colors"
          >
            ¿Olvidaste tu contraseña?
          </button>
        </div>
      </form>
    </div>

    <!-- Footer -->
    <div class="text-center text-xs text-gray-400 mt-6">© 2026 Himalaya Salud</div>
  </div>
</div>
